import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api from '@services/api';
import type { PortfolioType } from '@customTypes/portfolio';

type UseGetPortfolioProps = {
  portfolioId: string | null;
};

const useGetPortfolio = ({ portfolioId }: UseGetPortfolioProps) => {
  const [portfolio, setPortfolio] = useState<PortfolioType | null>(null);
  const [loading, setLoading] = useState(true);

  const getPortfolio = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(`/portfolio/${portfolioId}`);
      setPortfolio(response.data);
    } catch {
      toast.error('Erro ao carregar o portfólio. Tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  }, [portfolioId]);

  useEffect(() => {
    if (portfolioId) {
      getPortfolio();
    }
  }, [getPortfolio, portfolioId]);

  return {
    portfolio,
    loading,
  };
};

export default useGetPortfolio;
